module.exports = __webpack_public_path__ + "img/shiji-logo-v2.238db5e2.png";